import EventPublisher from "../utils/EventPublisher";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import ProfileAPIClient from "../client/ProfileAPIClient";

class ProfileActions {

    constructor() {
        this.profileApiClient = new ProfileAPIClient();
        EventPublisher.subscribe(UIInteractionEvents.RENDERED_VIEW_REQUIRES_PROFILE, this.handleProfileRequired);
        EventPublisher.subscribe(UIInteractionEvents.PROFILE_CREATE_SAVE_SUBMITTED, this.handleProfileSubmit);
        EventPublisher.subscribe(UIInteractionEvents.ADVERTISEMENT_OWNER_PROFILE_VIEW_MOUNTED, this.handleGetShareableProfileAdvertisementOwner);
        EventPublisher.subscribe(UIInteractionEvents.SPACE_OWNER_PROFILE_VIEW_MOUNTED, this.handleGetShareableProfileSpaceOwner);
        EventPublisher.subscribe(UIInteractionEvents.PROFILE_EDIT_SAVE_SUBMITTED, this.handleProfileEdit);

    }

    handleProfileRequired = (topic, data) => {
        this.profileApiClient.getProfile();
    };

    handleProfileSubmit = (topic, data) => {
        this.profileApiClient.submitProfile(data);
    };

    handleGetShareableProfileAdvertisementOwner = (topic, data) => {
        this.profileApiClient.getAdvertisementOwnerProfile(data);
    };

    handleGetShareableProfileSpaceOwner = (topic, data) => {
        this.profileApiClient.getSpaceOwnerProfile(data);
    };

    handleProfileEdit = (topic, data) => {
        this.profileApiClient.editProfile(data);
    }

}

export default new ProfileActions();
